import React from 'react';
import MainScreen from "../components/pages/MainScreen";
import MyMap from 'client_shared/src/components/maps/LazyMyMap';
import _ from 'lodash';
import {mapActions} from 'client_shared/src/state/actions/mapActions';

function Maps() {
    return (
        <MainScreen isMapScreen={true}>
            <MyMap/>
        </MainScreen>
    );

}

Maps.initState = (environment) => {
    const { dispatch, storeState } = environment;

    const promises = [];

    if (_.isEmpty(storeState.map.layers)) {
        promises.push(dispatch(mapActions.getLayers()));
    }

    return promises;
};

export default Maps;